'use strict';
const mmWidgets = require('./mm-widgets'),
	exportTableToText = require('../models/export-table-to-text');

require('./section-handler-widget');
mmWidgets.fn.measuresExportWidget = function (measuresModel, navigatorShim) {

	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			mimeType = 'text/tab-separated-values',
			exportType = element.find('[data-mm-role~="measures-export-type"]'),
			downloadLink = element.find('[data-mm-role~="export-measures"]'),
			sendToDriveUrl = element.find('[data-mm-role~="send-to-drive-url"]'),
			toObjectUrl = function (contents, mimeType) {
				if (/^data:[a-z]*\/[a-z]*/.test(contents)) {
					//TODO: I dont see how this will ever happen
					return navigatorShim.toObjectUrl(navigatorShim.dataUriToBlob(contents));
				}
				return navigatorShim.toObjectUrl(contents, mimeType);
			},
			setExportUrl = function () {
				const all = exportType.val() === 'measures-all' ? true : false,
					toSend = exportTableToText(measuresModel.getRawData(all)),
					objectUrl = toObjectUrl(toSend, mimeType);
				downloadLink.attr('download', measuresModel.getTitle()).attr('href', objectUrl).removeClass('disabled');
				sendToDriveUrl.val(objectUrl);
			},
			buildExportUrl = function () {
				downloadLink.addClass('disabled');
				setExportUrl();
			};


		element.on('show', function () {
			element.showSection('initial');
			buildExportUrl();
			exportType.focus();
		});
		exportType.on('change', buildExportUrl);
	});
};

